import React from "react";
import { Transport } from "@EUForms/transport";
import { useTranslation } from "@hooks/useTranslation";
import RepeatableContainer from "@containers/repeatableContainer";
// import { updateTransportationDetails,updateTransportationHeaderInfo } from "@commonActions/transportActions";
import WareHouseDetail from "./wareHouseDetail";
import SecurityInfoDetail from "./securityInfoDetail";
import GoodLocationDetail from "./goodLocationDetail";
import BorderTransportModeDetail from "./borderTransportModeDetail";
import { useDocument } from '@EUForms/hooks/useDocument'
import { CustomLoader } from "@commonComponents/formComponents/loader";
// import PreviousDocDetail from "./previousDocDetail";
// import AdditionalDocDetail from "./additionalDocDetail";
// import SupportingDocDetail from "./supportingDocDetail";
import DepartureTransportDetail from "./departureTransportDetail";
import InLandTransportDetail from "./inLandTransportDetail";
import CountryInfoDetail from "./countryInfoDetail";
import {useEvent} from "@hooks/useEvent"
import ActiveTransportDetail from "./activeTransportDetail";
import { selectSpecialCountryList } from "@EUForms/selectors";
import { useSelector } from "react-redux";
import   { transportTabActions } from "../../reducer/transportSlice";
import { useCustomOffices } from "@EUForms/hooks/useCustomOffices";
import CustomOfficeDetail from "@EUForms/customOffice";
import { useValidation } from "@EUForms/hooks/useValidation";
import { useCurrentShipmentType } from "@hooks/useCurrentShipmentType";
import { fieldPatterns } from "../../util/fieldPatterns";
import useNotEnable from "../../hooks/useNotEnable";

const TransportContainer=({repeatableValidationMethods})=> {
  const translate = useTranslation()
  const {isImportShipment} = useCurrentShipmentType()
  const countryList=useSelector(selectSpecialCountryList)
  const{ addItemTransport, deleteItemTransport, updateItemTransport, updateTransportDetails, updateTransportHeaderInfo }= transportTabActions
  const {isLoading,...rest}=useDocument({addData:addItemTransport,deleteData:deleteItemTransport,updateData:updateItemTransport,containerKey:"transportTab"})
  const {isLoading:Loading,...restData}=useCustomOffices({addData:addItemTransport,deleteData:deleteItemTransport,updateData:updateItemTransport,containerKey:"transportTab"})
 const {saveForm}=useEvent("transportTab")
 const {validateError} = useValidation('transportTab')
 const fieldPattern = fieldPatterns(isImportShipment,translate)
const {isDisabled} = useCurrentShipmentType()
 const disabled = useNotEnable()

  return (
    <div className='transportContainer formContentareaC88'>
      {isLoading && <CustomLoader style={{ position: 'fixed' }} />}
      <Transport>
        <CountryInfoDetail
          saveData={saveForm}
          updateData={updateTransportDetails}
          updateHeaderData={updateTransportHeaderInfo}
          fieldPattern={fieldPattern}
          validateError={validateError}
          renderForm={(params) => (
            <Transport.CountryInfoForm countryList={countryList} {...params} />
          )}
        />
        <GoodLocationDetail
          saveData={saveForm}
          translate={translate}
          updateData={updateTransportDetails}
          fieldPattern={fieldPattern}
          validateError={validateError}
          renderForm={(params) => <Transport.GoodLocationForm {...params} />}
        />
        <WareHouseDetail
          saveData={saveForm}
          // fieldPattern={fieldPattern}
          // validateError={validateError}
          updateData={updateTransportDetails}
          renderForm={(params) => <Transport.WareHouseDetailForm {...params} />}
        />

        <BorderTransportModeDetail
          saveData={saveForm}
          updateData={updateTransportDetails}
          renderForm={(params) => <Transport.BorderTransportModeForm {...params} disabled={disabled} />}
        />

        <div className='row border-0'>
          <InLandTransportDetail
            saveData={saveForm}
            updateData={updateTransportHeaderInfo}
            repeatableValidationMethods={repeatableValidationMethods}
            renderForm={(params) => (
              <Transport.InLandTransportForm className='grow mb-2' {...params} />
            )}
          />
          <ActiveTransportDetail
            translate={translate}
            {...rest}
            renderForm={(params) => (
              <Transport.ActiveTransportForm
                repeatableValidationMethods={repeatableValidationMethods}
                disabled={disabled}
                countryList={countryList}
                {...params}
                className='grow mb-2'
              />
            )}
          />
        </div>

        <Transport.RoutingCountry countryList={countryList} {...rest} />

        <SecurityInfoDetail
          saveData={saveForm}
          updateData={updateTransportHeaderInfo}
          validateError={validateError}
          fieldPattern={fieldPattern}
          renderForm={(params) => <Transport.SecurityInfoForm {...params} />}
        />
      </Transport>
      <RepeatableContainer
        {...rest}
        validateError={repeatableValidationMethods?.validateError}
        updateErrors={repeatableValidationMethods?.updateErrors}
        tableName='departureTransportMeansList'
        boxNumber='7/7'
        reducerName='transportReducer'
        title='DEPARTURE_TRANSPORT_MEANS'
        translate={translate}
        renderForm={(params) => (
          <DepartureTransportDetail
            {...params}
            renderForm={(props) => (
              <div className='formContainer'>
                <Transport.TransportModeForm countryList={countryList} {...props} />
              </div>
            )}
          />
        )}
      />
      <RepeatableContainer
        {...restData}
        tableName='customOfficesList'
        reducerName='transportReducer'
        title='CUSTOMS_OFFICES'
        translate={translate}
        maxRowsAllowed={4}
        renderForm={(params) => <CustomOfficeDetail isDisabled={isDisabled} {...params} />}
      />
      {/* <RepeatableContainer 
            {...rest}
            tableName="previousDocumentsList"
            reducerName="transportReducer"
            title="PREVIOUS DOCUMENT"
            translate={translate}
            boxNumber="2/1" 
            renderForm={(params)=><PreviousDocDetail {...params}/>}
          />
             <RepeatableContainer 
            {...rest}
            tableName="additionalDocumentsList"
            reducerName="transportReducer"
            title="ADDITIONAL DOCUMENT"
            translate={translate}
            boxNumber="2/2" 
            renderForm={(params)=><AdditionalDocDetail {...params}/>}
          />
             <RepeatableContainer 
            {...rest}
            tableName="supportingDocumentsList"
            reducerName="transportReducer"
            title="SUPPORTING DOCUMENTS"
            translate={translate}
            boxNumber="2/3" 
            renderForm={(params)=><SupportingDocDetail {...params}/>}
          /> */}
    </div>
  )
}

export default React.memo(TransportContainer)
